import React from "react";
import DigestItem from "./DigestItem";
import { DigestItem as DigestItemType } from "../../gql/types";
import DigestHeader from "./DigestHeader";
import HomeCard from "../home/card/HomeCard";
import { computeDigestHeader } from "./computeDigestHeader";

type DigestCardProps = {
    item: DigestItemType;
};

const DigestCard: React.FC<DigestCardProps> = ({ item }) => {
    const computedHeader = computeDigestHeader(item);

    return (
        <HomeCard
            header={(
                <DigestHeader
                    topTitle={computedHeader.topTitle}
                    mainTitle={computedHeader.mainTitle}
                    attentionLevel={computedHeader.attentionLevel}
                    description={computedHeader.description}
                />
            )}
        >
            <DigestItem item={item} />
        </HomeCard>
    );
};

export default DigestCard;
